import { render, staticRenderFns } from "./MolliePayments.vue?vue&type=template&id=4b437117&scoped=true&"
import script from "./MolliePayments.vue?vue&type=script&lang=js&"
export * from "./MolliePayments.vue?vue&type=script&lang=js&"
import style0 from "./MolliePayments.vue?vue&type=style&index=0&id=4b437117&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b437117",
  null
  
)

export default component.exports